import { type SVGProps } from 'react';
import { type IconProps } from '@/components/uielements/icon/types';

export const CheckMarkCircle = ({
  title,
  width,
  height,
  ...otherProps
}: IconProps & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...otherProps}
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '24'}
      height={height ?? '24'}
      viewBox="0 0 24 24"
      fill="none"
    >
      <title>{title ?? 'Check Mark Circle'}</title>
      <path
        d="M21.801 9.9995C22.2577 12.2408 21.9322 14.5709 20.8788 16.6013C19.8255 18.6317 18.1079 20.2396 16.0125 21.1568C13.9171 22.0741 11.5706 22.2453 9.36428 21.6419C7.15795 21.0385 5.22517 19.6969 3.88825 17.8409C2.55134 15.9849 1.8911 13.7267 2.01764 11.4429C2.14418 9.15904 3.04986 6.98759 4.58363 5.29067C6.1174 3.59375 8.18656 2.47393 10.446 2.11795C12.7055 1.76198 15.0188 2.19136 17 3.3345"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11L12 14L22 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
